// 予期せぬ切断を検知してから「接続が切れました」info トーストを実表示するまでの遅延（ms）を求める。
//
// 意図する挙動は 2 つある。
//  1. 裏タブ/最小化からの復帰で走る一瞬の正当な再接続では通知しない（デバウンス）。
//  2. 直前の再接続成功から一定時間（クールダウン）内に再び切れても、フラップのたびにトーストを
//     積み上げない。ただしクールダウン中に始まった切断でも、そのまま長時間復旧しない場合は
//     最終的に必ず通知する（無通知のまま放置しない）。
//
// これを満たすため、遅延は「デバウンス」と「クールダウン残り時間」のうち長い方とする。
// クールダウン中はクールダウン終了時点まで表示を待ち、その前に再接続が成功すれば予約は取り消され
// 無音で復帰する。クールダウン外では単純にデバウンスぶんだけ待つ。
export function computeDisconnectToastDelayMs(
  now: number,
  reconnectToastCooldownUntil: number,
  debounceMs: number
): number {
  const cooldownRemaining = reconnectToastCooldownUntil > now ? reconnectToastCooldownUntil - now : 0;
  return Math.max(debounceMs, cooldownRemaining);
}
